import styled from 'styled-components';

const StyledBackground = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: rgba(17, 19, 20, 0.75);
`;

export { StyledBackground };
